import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { NavBarDataService } from "../services/navbar.service";
import { SharedDataService } from "../services/shared.service";
declare var $: any;
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  public fullscreen = false;
  //For logo related
  public tenantId: any;
  public getLogo: string;
  // End
  public alerts;
  public PushObject;
  public tenantExpiry: any;
  public firstLoad = true;
  public Items: any;
  public getId: any;
  public elem = document.documentElement;
  public selectedId: any;
  public searchlink;
  public searchText;
  public typing = "contents";
  public displayBlock = "none";
  public menuFind = [];
  public totalFound;
  public class = true;
  constructor(
    private router: Router,
    private _NavBarDataService: NavBarDataService,
    private SharedDataService: SharedDataService,
  ) {}

  urlLinks = [
    { name: "Dashboard", link: "dashboard", icon: "ti-home" },
    { name: "Thing Manager", link: "things-manager", icon: "ti-plug" },
    {
      name: "Template Manager",
      link: "templates-manager",
      icon: "ti-harddrives",
    },
    { name: "Project", link: "projects", icon: "ti-view-list" },
    { name: "Visualization", link: "visualization", icon: "ti-bar-chart-alt" },
    { name: "Analytics", link: "analytics", icon: "ti-stats-up" },
    { name: "Data Store", link: "dashboard", icon: "ti-server" },
    { name: "Deep Learning", link: "DeepLearning", icon: "fa fa-cubes" },
    { name: "User Manager", link: "users-manager", icon: "ti-user" },
    { name: "Rule Engine", link: "rules", icon: "ti-vector" },
  ];

  ngOnInit() {
    this.navbarLogoUpdate();
    // this.SharedDataService._comp1ValueBS.subscribe((element) => {
    //   this.PushObject = element;
    //   // console.log(element);
    // });
    // this._NavBarDataService
    //   .getAllAlertLevel("eq", "isSeen", "false")
    //   .subscribe((res) => {
    //     this.alerts = res.body["data"];
    //   });
    // this.getAllProjects();
    // this.usersDataService.details().subscribe(data => {
    //     this.user = data.body as IUser;
    // });
    let obj = {
      link: "test",
      name: "Menu",
      icon: "ti-marker",
      description: "this is testing search",
    };
    // this.menuFind.push(obj);
    let obj1 = {
      link: "test",
      name: "Submenu",
      icon: "ti-marker",
      description: "this is testing search",
    };
    // this.menuFind.push(obj1);
    // setInterval(() => {
    //   this._NavBarDataService
    //     .getAllAlertLevel("eq", "isSeen", "false")
    //     .subscribe((res) => {
    //       this.alerts = res.body["data"];
    //     });
    // }, 300000);
  }

  navbarLogoUpdate() {
    this.tenantExpiry = localStorage.getItem("tenantExpiry");

    // For logo related
    //  let decodeToken = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    let decodeToken = JSON.parse(
      atob(
        localStorage.getItem(environment.ProjectName + "-token").split(".")[1],
      ),
    );

    this.tenantId = decodeToken.tenantId;
    this.getLogo =
      environment.IDENTITY + "/cdn/tenants/logo/" + this.tenantId + ".png";
  }

  // getAllProjects() {
  //
  //   this._NavBarDataService.getAllProject().subscribe((res) => {
  //
  //     this.Items = res.body["data"];
  //     console.log("Wn Items", this.Items);
  //     if (localStorage.getItem("projectId") == null) {
  //       this.getId = this.Items[0].id;
  //       console.log("DropDown ID", this.getId);
  //       localStorage.setItem("projectId", this.getId);
  //     } else {
  //       this.getId = JSON.parse(localStorage.getItem("projectId"));
  //     }
  //   });
  // }
  public setting: any = {
    idField: "id",
    // imageField: 'image',
    textField: "name",
    subField: "description",
  };

  // onSelectProject(event) {
  //   //

  //   if (localStorage.getItem("projectId") == null) {
  //     if (this.firstLoad) {
  //       this.firstLoad = false;
  //       console.log("Event", event);
  //       localStorage.setItem("projectId", event.id);
  //     } else {
  //       // alert();
  //       // window.location.reload();
  //       this.firstLoad = false;
  //     }
  //   } else {
  //     if (this.firstLoad) {
  //       this.firstLoad = false;
  //       console.log("Event", event);
  //       localStorage.setItem("projectId", event.id);
  //     } else {
  //       this.firstLoad = false;
  //       console.log("Event", event);
  //       localStorage.setItem("projectId", event.id);
  //       window.location.reload();
  //     }
  //   }

  //   // window.location.reload();
  // }
  signOut(e) {
    e.preventDefault();
    // localStorage.removeItem("token");
    localStorage.removeItem(environment.ProjectName + "-token");
    this.router.navigate(["/sso/login"]);
    // window.location.href = this.appUrlsService.signOutRedirectUrl;
  }

  onKeydown(event) {
    this.displayBlock = "block";
    //console.log(event.key);
    let word = event.key;
    if (event.key != "Enter" && event.key != "Backspace") {
      this.searchlink = this.urlLinks.filter((x) => {
        return x.name.toLowerCase().includes(word.toLowerCase());
      });
      this.typing = "contents";
      if (event.key == "ArrowUp") {
      }
      //this.searchlink=this.urlLinks.find(x=>x.name.toLowerCase().includes(word.toLowerCase()));
    } else if (event.key === "Backspace") {
      word = this.searchText;
      // this.searchlink=this.urlLinks.find(x=>x.name.toLowerCase().includes(word.toLowerCase()));
      this.searchlink = this.urlLinks.filter((x) => {
        return x.name.toLowerCase().includes(word.toLowerCase());
      });
      this.typing = "contents";
    } else if (event.key === "Enter") {
      this.menuFind = [];
      word = this.searchText;
      this.searchlink = this.urlLinks.filter((x) => {
        return x.name.toLowerCase().includes(word.toLowerCase());
      });
      //this.searchlink=this.urlLinks.find(x=>x.name.toLowerCase().includes(word.toLowerCase()));
      //this.router.navigate([`/search/${word}`])
      // this.router.navigate([`/${this.searchlink.link}`]);
      this.displayBlock = "block";

      this.menuFind = this.searchlink;
      this.totalFound = this.menuFind.length;
      this.typing = "none";
      //console.log(this.searchlink);
    }
  }

  openFullscreen() {
    //    this.fullscreen=true;
    // if (this.elem.requestFullscreen) {
    //   this.elem.requestFullscreen();
    // } else if (this.elem.mozRequestFullScreen) { /* Firefox */
    //   this.elem.mozRequestFullScreen();
    // } else if (this.elem.webkitRequestFullScreen) { /* Chrome, Safari & Opera */
    //   this.elem.webkitRequestFullScreen();
    // } else if (this.elem.msRequestFullscreen) { /* IE/Edge */
    //   this.elem.msRequestFullscreen();
    // }
  }

  closeFullscreen() {
    //    this.fullscreen=false;
    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } else if (document.mozCancelFullScreen) {
    //   document.mozCancelFullScreen();
    // } else if (document.webkitExitFullscreen) {
    //   document.webkitExitFullscreen();
    // } else if (document.msExitFullscreen) {
    //   document.msExitFullscreen();
    // }
  }

  ToggleMenuCustome() {
    if (this.class) {
      $("#bodySidebar").addClass("sidebar-icon-only");
      this.class = !this.class;
    } else {
      $("#bodySidebar").removeClass("sidebar-icon-only");
      this.class = !this.class;
    }
  }
  focusFunction() {
    this.displayBlock = "block";
  }
  focusOutFunction() {
    setTimeout(() => {
      this.displayBlock = "none";
    }, 100);
  }
  navigateToRoute(link, search) {
    this.searchText = search;
    this.displayBlock = "none";
    this.router.navigate(["/" + link]);
  }
  DivActive() {
    if (this.displayBlock == "block") {
      $(".fx-custom-search").removeClass("fx-custom-search-white");
      $(".rotate").removeClass("rotateMove btn btn-primary btn-sm");
      $(".fx-custom-background").removeClass("fx-more-color");
      $(".fx-custome-search").removeClass("fx-custom-navbar-block-size");
      this.displayBlock = "none";
    } else {
      this.displayBlock = "block";
      $(".fx-custom-search").toggleClass("fx-custom-search-white");
      $(".rotate").toggleClass("rotateMove btn btn-primary btn-sm");
      $(".fx-custom-background").toggleClass("fx-more-color");
      $(".fx-custome-search").addClass("fx-custom-navbar-block-size");
    }
  }
  divFoucOut() {
    setTimeout(() => {
      $(".fx-custom-search").removeClass("fx-custom-search-white");
      $(".rotate").removeClass("rotateMove btn btn-primary btn-sm");
      $(".fx-custom-background").removeClass("fx-more-color");
      $(".fx-custome-search").toggleClass("fx-custom-navbar-block-size");
      this.displayBlock = "none";
    }, 100);
  }
  SettingPanelToggle() {
    $("#theme-settings").toggleClass("open");
  }
  showMobileMenu() {
    $(".sidebar").toggleClass("active");
  }

  Logout() {
    // localStorage.removeItem("token");
    localStorage.removeItem(environment.ProjectName + "-token");
    this.SharedDataService.sideMenusList = [];
    this.SharedDataService.sidebarURLs = [];
    this.SharedDataService.isSidebarLoaded = false;
    this.router.navigate(["/sso/login"]);
  }
}
